import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    console.warn("404: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center space-y-4">
        <h1 className="text-6xl font-bold text-primary">404</h1>
        <p className="text-xl text-muted-foreground">
          {t("الصفحة غير موجودة", "Oops! Page not found")}
        </p>
        <p className="text-sm text-muted-foreground max-w-md">
          {t("الصفحة التي تبحث عنها غير موجودة أو تم نقلها", "The page you're looking for doesn't exist or has been moved")}
        </p>
        <div className="flex gap-3 justify-center pt-4">
          <Button variant="outline" onClick={() => navigate(-1)} className="gap-2">
            <ArrowLeft className="h-4 w-4 rtl:rotate-180" />
            {t("رجوع", "Go Back")}
          </Button>
          <Button onClick={() => navigate("/dashboard")} className="gap-2">
            <Home className="h-4 w-4" />
            {t("لوحة التحكم", "Dashboard")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
